import { useIonModal } from '@ionic/react';
import { FullPost } from 'model';
import { useUpdateDisplayCommentsMutation } from '../api/PostApi';
import { Confirmation } from '../pages/Confirmation';

// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
import { IconButton } from './IconButton';
import { PostContentsToHTML } from './PostContentsToHTML';
import { IconEye, IconEyeOff, IconInfo } from './QuirkIcons';
import { TruncatedSummary } from './TruncatedSummary';
interface HideCommentsType {
	post: FullPost;
	action?: () => void;
}
export const HideComments: React.FC<HideCommentsType> = ({ post, action }) => {
	const [updateDisplayComments] = useUpdateDisplayCommentsMutation();
	const { displayComments } = post;
	const onHideComments = async () => {
		dismiss();
		await updateDisplayComments({ postid: post._id, display: !post.displayComments });
		action && action();
	};

	const removeTooltip = async (dismiss: () => void) => {
		await dismiss();
		action && action();
	};
	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => removeTooltip(dismiss),
		action: onHideComments,
		actionLabel: displayComments ? 'Hide Comments' : 'Show Comments ',
		dismissLabel: 'Cancel',
		content: (
			<>
				<h4>Are you sure you want to {displayComments ? 'hide ' : 'show '}comments on this post?</h4>
				<div className={sharedstyles.modalDescription}>
					<IconInfo />
					<div>
						{displayComments
							? 'People will no longer be able to view comments on this post.'
							: 'This will allow people to view comments on this post.'}
					</div>
				</div>
				<TruncatedSummary>
					<PostContentsToHTML>{post?.contents}</PostContentsToHTML>
				</TruncatedSummary>
			</>
		)
	});

	return (
		<IconButton
			label={!displayComments ? 'Show Comments' : 'Hide Comments'}
			icon={!displayComments ? <IconEye /> : <IconEyeOff />}
			onClick={present}
			testId="ShowHideCommentsButton"
		/>
	);
};
